module.exports = __webpack_public_path__ + "img/baseline-keyboard_arrow_down-24px.1c9f9d8a.svg";